// https://github.com/hirak/phpjs/blob/ead6d1a542a0ce0b3969e2c1ea42e9213d12214d/functions/strings/htmlspecialchars_decode.js

const unescapeHtml = (str) =>
  str
    .replaceAll('&lt;', '<')
    .replaceAll('&gt;', '>')
    .replaceAll('&#0*39;', "'")
    .replaceAll('&apos;', "'")
    .replaceAll('&#x0*27;', "'")
    .replaceAll('&quot;', '"')
    .replaceAll('&amp;', '&');

const productsBrowserProduct = () => ({
  currentImageIndex: 0,

  get name() {
    return unescapeHtml(this.product.name);
  },

  get link() {
    return `${window.Shopify.routes.root}products/${this.product.handle}`;
  },

  get images() {
    const images = (this.product.images || '').split('|');
    const alts = (this.product.images_alt || '')
      .split('|')
      .map((alt) => (alt === 'null' ? '' : alt || ''));

    return images.map((image, index) => ({
      src: image,
      alt: alts[index],
    }));
  },

  get variants() {
    return JSON.parse(unescapeHtml(this.product.variants));
  },

  get currentImage() {
    return this.images[this.currentImageIndex];
  },

  nextImageHandle() {
    this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
  },

  async selectVariantHandler(e) {
    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'post',
      body: JSON.stringify({ items: [{ id: e.target.value }] }),
      headers: { 'content-type': 'application/json' },
    });
    window.location.href = `${window.Shopify.routes.root}cart.js`;
  },
});

export default productsBrowserProduct;
